
import { defineComponent } from "vue"
import CardVersionsIndex from "@/components/card_versions/Index.vue"

export default defineComponent({
  components: {
    CardVersionsIndex
  }
})
